export default {
  setCart(state, payload) {
    state.shoppingCart = payload;
  },
  setOrderCart(state, payload) {
    state.orderCart = payload;
  },
  setRequestSource(state, payload) {
    state.requestSource = payload;
  },
  setEditOrderId(state, payload) {
    state.editOrderId = payload;
  },
};
